import React from 'react'

import {Divider} from '@vio/atlas/Divider'
import {Box} from '@vio/atlas/helpers/Box'
import {SkeletonLoader} from '@vio/atlas/SkeletonLoader'

import {Card, PhotoWrapper} from './styles'

export const SimilarHotelSkeleton = () => (
  <Card
    as="div"
    aria-hidden="true"
    style={{cursor: 'default'}}
    data-testid="similar-hotel-skeleton"
  >
    <PhotoWrapper>
      <SkeletonLoader height="100%" />
    </PhotoWrapper>
    <Box display="flex" flex="1" flexDirection="column" minWidth="0">
      <Box
        display="flex"
        flexDirection="column"
        gap="s600"
        minWidth="0"
        paddingTop="s300"
        paddingBottom="s600"
        paddingLeft="s400"
        paddingRight="s400"
      >
        <div>
          <SkeletonLoader width={93} />
          <SkeletonLoader />
        </div>
        <div>
          <SkeletonLoader width={165} />
          <SkeletonLoader width={124} />
        </div>
      </Box>
      <Box marginTop="auto">
        <Divider />
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          paddingTop="s400"
          paddingBottom="s400"
          paddingLeft="s400"
          paddingRight="s400"
        >
          <SkeletonLoader width={72} />
          <SkeletonLoader width={53} marginTop={0} />
        </Box>
      </Box>
    </Box>
  </Card>
)
